export const SET_SIGNED_DOCS = 'SET_SIGNED_DOCS'
export const SET_UNSIGNED_DOCS = 'SET_UNSIGNED_DOCS'
export const SET_UNSIGNED_TOTAL_DOCS = 'SET_UNSIGNED_TOTAL_DOCS'
export const SET_EFIMERO_FOLDERS = 'SET_EFIMERO_FOLDER'
export const SET_ENABLE_DOCS = 'SET_ENABLE_DOCS'
export const SET_DOCUMENT_SELECTED = 'SET_DOCUMENT_SELECTED'
export const SET_IMAGEVALUE = 'SET_IMAGE_VALUE'
export const UPDATE_DOCUMENT_SELECTED = 'UPDATE_DOCUMENT_SELECTED'
export const UPDATE_EFORM_SIGNED = 'UPDATE_EFORM_SIGNED'
export const SET_LOADING_IMAGE = 'SET_LOADING_IMAGE'
export const SET_DOCUMENT_FILE = 'SET_DOCUMENT_FILE'
export const SET_NUMBER_PAGE = 'SET_NUMBER_PAGE'
export const SET_TOTAL_PAGES = 'SET_TOTAL_PAGES'
export const SET_REQUESTED_LIST = 'SET_REQUESTED_LIST'
export const SET_SIGNED_LAST_DOC_ID = 'SET_SIGNED_LAST_DOC_ID'
export const SET_UNSIGNED_LAST_DOC_ID = 'SET_UNSIGNED_LAST_DOC_ID'
export const SET_DOCUMENTS_UNSIGNED_PARAMS_FILTER = 'SET_DOCUMENTS_UNSIGNED_PARAMS_FILTER'
export const SET_DOCUMENTS_SIGNED_PARAMS_FILTER = 'SET_DOCUMENTS_SIGNED_PARAMS_FILTER'
export const SET_FOLDERS_AVAILABLES= 'SET_FOLDERS_AVAILABLES'
export const CLEAR_ALL_DOCUMENTS_STATE = 'CLEAR_ALL_DOCUMENTS_STATE'